import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import AuthWrapper from './common/AuthWrapper';
import InputWrapper from '../common/InputWrapper';
// import ErrorBlock from '../common/ErrorBlock'
import Button from '../common/Button';

import { fetchRecovery } from '../../actions/auth';

import { preventSubmittingByEnter, parseError } from '../../helpers';
import { useEffect } from 'react';

const validationSchema = Yup.object().shape({
  password: Yup.string().trim().required('Введите пароль'),
  confirm: Yup.string()
    .trim()
    .oneOf([Yup.ref('password'), null], 'Пароли не совпадают'),
});

const RecoveryPage = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    if (history.location.search && history.location.search.indexOf('?t=') !== -1) {
      const newTokenSplitted = history.location.search.split('?t=');
      setToken(newTokenSplitted[1]);
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      password: '',
      confirm: '',
    },
    onSubmit: async (values) => {
      setLoading(true);
      const { password } = values;
      await dispatch(
        fetchRecovery({
          token,
          password,
        }),
      )
        .then(() => {
          toast.info('Пароль успешно обновлен');
          history.push('/sign_in');
        })
        .catch((err) => {
          toast.error(parseError(err));
        })
        .finally(() => {
          setLoading(false);
        });
    },
    validationSchema,
  });

  const {
    values,
    errors,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
    isValid,
  } = formik;

  return (
    <AuthWrapper>
      <div style={{ textAlign: 'center', marginBottom: '25px' }}>
        <h4>Восстановление пароля</h4>
      </div>
      <form onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <InputWrapper
            type="password"
            label="Пароль"
            id="password"
            value={values.password}
            error={errors.password}
            showValidation={submitCount}
            onChange={handleChange}
            placeholder="Введите новый пароль"
            testId="RecoveryPageNewPass"
          />
        </div>

        <div className="form-group mb-3">
          <InputWrapper
            type="password"
            label="Подтверждение"
            id="confirm"
            value={values.confirm}
            error={errors.confirm}
            showValidation={submitCount}
            onChange={handleChange}
            placeholder="Введите подтверждение пароля"
            testId="RecoveryPageConfirmPass"
          />
        </div>

        <div className="form-group mb-0 text-center">
          <Button
            type="submit"
            text="Отправить"
            loading={loading}
            disabled={loading || !isValid || !token}
            style={{ width: '100%' }}
          />
        </div>
      </form>
    </AuthWrapper>
  );
};

export default RecoveryPage;
